/* eslint react/prop-types: 0 */
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ArrowLeft } from "lucide-react";

/**
 * iter118 - Sticky "back to dashboard" pill.
 *
 * Floats in the bottom-left corner on every authenticated non-dashboard
 * page so the user always has a one-tap escape hatch. Mirrors Breadcrumbs'
 * HIDE list so the two together stay consistent.
 */
const ROLE_HOME = {
  educator: { to: "/educator", label: "Dashboard" },
  parent:   { to: "/parent",   label: "Dashboard" },
  admin:    { to: "/admin/dashboard", label: "Dashboard" },
};

const HIDE_ON_PATHS = new Set([
  "/", "/login", "/register", "/forgot-password", "/reset-password",
  "/pricing", "/about", "/contact", "/legal", "/legal/privacy",
  "/legal/terms", "/legal/acceptable-use",
  "/educator", "/educator/dashboard",
  "/parent", "/parent/dashboard",
  "/admin", "/admin/dashboard",
]);

export default function FloatingBackButton() {
  const { user } = useAuth();
  const loc = useLocation();
  if (!user || HIDE_ON_PATHS.has(loc.pathname)) return null;
  const home = ROLE_HOME[user.role] || ROLE_HOME.parent;
  return (
    <Link
      to={home.to}
      data-testid="floating-back-to-dashboard"
      aria-label="Back to dashboard"
      className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-1.5 h-11 px-4 rounded-full bg-[#0F1830] text-white text-sm font-semibold shadow-lg hover:bg-[#1A2747] transition-colors print:hidden"
    >
      <ArrowLeft className="h-4 w-4" /> {home.label}
    </Link>
  );
}
